import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import {
	dashboard_icon,
	rdv_icon,
	attente_icon,
	settings_icon,
	logout_icon,
	signed_offer_icon,
	history_icon,
} from '../../../utils/images';
import { ProfileContext } from '../../Contexts/contexts';

function SideMenuExpert(props) {
	const profileContext = useContext(ProfileContext);

	return (
		<>
			<div className="side-menu-container side-menu-expert">
				<div className="side-menu-upper">
					<div
						className={
							'side-menu-element' + (props.path === '/' ? ' selected' : '')
						}
					>
						<Link to="/">
							<img
								src={dashboard_icon}
								alt="dashboard icon"
								className="side-menu-icon"
							/>
							<span>Tableau de bord</span>
						</Link>
					</div>
					<div
						className={
							'side-menu-element' +
							(props.path === '/waiting-acceptation' ? ' selected' : '')
						}
					>
						<Link to="/waiting-acceptation">
							<img
								src={attente_icon}
								alt="attente icon"
								className="side-menu-icon"
							/>
							<span>En attente d’acceptation</span>
						</Link>
					</div>
					<div
						className={
							'side-menu-element' +
							(props.path === '/accepted-rdv' ? ' selected' : '')
						}
					>
						<Link to="/accepted-rdv">
							<img src={rdv_icon} alt="rdv icon" className="side-menu-icon" />
							<span>Rendez-vous accepté</span>
						</Link>
					</div>
					<div
						className={
							'side-menu-element' +
							(props.path === '/payment-quote' ? ' selected' : '')
						}
					>
						<Link to="/payment-quote">
							<img
								src={signed_offer_icon}
								alt="avis icon"
								className="side-menu-icon"
							/>
							<span>Commissions à payer</span>
						</Link>
					</div>
					<div
						className={
							'side-menu-element' +
							(props.path === '/client-history' ? ' selected' : '')
						}
					>
						<Link to="/client-history">
							<img
								src={history_icon}
								alt="partager icon"
								className="side-menu-icon"
							/>
							<span>Historique clients</span>
						</Link>
					</div>
				</div>

				<div className="side-menu-bottom">
					<div className="side-menu-element">
						<Link to="/settings">
							<img
								src={settings_icon}
								alt="settings logo"
								className="side-menu-icon"
							/>
							<span>Réglages</span>
						</Link>
					</div>
					<div className="side-menu-element" onClick={profileContext.logout}>
						<Link to="#">
							<img
								src={logout_icon}
								alt="logout logo"
								className="side-menu-icon"
							/>
							<span>Se déconnecter</span>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}

export default SideMenuExpert;
